import Vue from 'vue'
import Vuex from 'vuex';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './registerServiceWorker'
import VueCodemirror from 'vue-codemirror'
import Buefy from 'buefy'


// require styles
import 'codemirror/lib/codemirror.css'

Vue.prototype.$axios = axios;
Vue.use(Vuex);
Vue.use(Buefy);
Vue.use(VueCodemirror, /* { 
  options: { theme: 'base16-dark', ... },
  events: ['scroll', ...]
} */)
import Firebase from "./firebase";
Firebase.init();
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
